// extracted by mini-css-extract-plugin
export default {"analyticCustomerPage":"AnalyticCustomersPage_analyticCustomerPage__fzVGK"};